import { UserSchema } from '@/types/schema/user-schema'
import { UserGroup } from '@/types/user'

export const getUserGroup = (type: UserSchema['type']): UserGroup => {
  return type === 'ad' ? 'ad' : 'kol'
}
